/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InvoiceLineItemSchema
 */
export interface InvoiceLineItemSchema {
    /**
     * 
     * @type {string}
     * @memberof InvoiceLineItemSchema
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceLineItemSchema
     */
    stripeId: string;
    /**
     * 
     * @type {number}
     * @memberof InvoiceLineItemSchema
     */
    amountCents: number;
    /**
     * 
     * @type {Date}
     * @memberof InvoiceLineItemSchema
     */
    periodStart: Date;
    /**
     * 
     * @type {Date}
     * @memberof InvoiceLineItemSchema
     */
    periodEnd: Date;
    /**
     * 
     * @type {boolean}
     * @memberof InvoiceLineItemSchema
     */
    proration: boolean;
}

/**
 * Check if a given object implements the InvoiceLineItemSchema interface.
 */
export function instanceOfInvoiceLineItemSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "description" in value;
    isInstance = isInstance && "stripeId" in value;
    isInstance = isInstance && "amountCents" in value;
    isInstance = isInstance && "periodStart" in value;
    isInstance = isInstance && "periodEnd" in value;
    isInstance = isInstance && "proration" in value;

    return isInstance;
}

export function InvoiceLineItemSchemaFromJSON(json: any): InvoiceLineItemSchema {
    return InvoiceLineItemSchemaFromJSONTyped(json, false);
}

export function InvoiceLineItemSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvoiceLineItemSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'description': json['description'],
        'stripeId': json['stripe_id'],
        'amountCents': json['amount_cents'],
        'periodStart': (new Date(json['period_start'])),
        'periodEnd': (new Date(json['period_end'])),
        'proration': json['proration'],
    };
}

export function InvoiceLineItemSchemaToJSON(value?: InvoiceLineItemSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'description': value.description,
        'stripe_id': value.stripeId,
        'amount_cents': value.amountCents,
        'period_start': (value.periodStart.toISOString()),
        'period_end': (value.periodEnd.toISOString()),
        'proration': value.proration,
    };
}

